import type { NativeContextRNProps } from "../props/NativeContextRNProps";

import { getDeviceProperties } from "./LoggableDeviceProperties";
import { getRnErrorProviderId } from "../util/getRnErrorProviderId";
import { isSSR } from "../util/isSSR";

import {
  AvroOptional,
  log as signalsLogHttpError,
} from "@indeed/signals-schema/com/indeed/signals/schema/reactnative/RNHttpErrorV5";

/**
 * Log an error that occurred during a network request using signals
 * @param url the url that was requested
 * @param message the error message
 */
export function logHttpError(
  provider: string,
  url: string,
  message: string,
  statusCode: number,
  nativeContext: NativeContextRNProps | undefined | null,
): void {
  // Signals logging relies on browser/native APIs that are unavailable during SSR.
  if (isSSR()) return;
  const { ctk, accountId } = nativeContext ?? {};
  signalsLogHttpError({
    provider: AvroOptional.string(provider),
    providerId: { ProviderId: getRnErrorProviderId(provider) },
    deviceProperties: getDeviceProperties(),
    url,
    message,
    statusCode,
    ctk: AvroOptional.string(ctk),
    accountId: AvroOptional.string(accountId),
  });
}
